(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gv-home-bonus"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gv-home-bonus')) {
    customElements.define('gv-home-bonus', class extends HTMLElement {
      connectedCallback() {
        const translate = () => {
          const input = this.querySelector('input[type="email"]');
          if (input) {
            input.setAttribute('aria-label', this.dataset.emailLabel);
            if (/^e-?mail$/i.test(input.placeholder.trim())) input.placeholder = this.dataset.emailLabel;
          }
          for (const label of this.querySelectorAll('label')) {
            if (/^e-?mail$/i.test(label.textContent.trim())) label.textContent = this.dataset.emailLabel;
          }
          for (const button of this.querySelectorAll('button')) {
            if (/^subscribe$/i.test(button.textContent.trim())) button.textContent = this.dataset.buttonLabel;
          }
        };
        this.observer = new MutationObserver(translate);
        this.observer.observe(this, {childList: true, subtree: true});
        translate();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            this.classList.add('products-loaded');
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
